import { createSelector } from 'reselect';
import DespatchParticularsReceptacleTypeColumns from '../../containers/DespatchMeasurementsHourlyEvolutionColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.DESPATCH_MEASUREMENTS_HOURLY_EVOLUTION.metadata.generatedOnDateTime;

export const getIsLoading = state => state.reporting.DESPATCH_MEASUREMENTS_HOURLY_EVOLUTION.isLoading;

export const getData = ReportDefinitions.DESPATCH_MEASUREMENTS_HOURLY_EVOLUTION.getDataFunction();

export const getColumns = createSelector(getData, DespatchParticularsReceptacleTypeColumns);
